/**
 * Important: We are moving away from using globally-managed modals via compose-app.
 * Please manage your modals with local state.
 *
 */

export const ADD_BACKGROUND = 'ADD_BACKGROUND';
export const ADD_CONTENT = 'ADD_CONTENT';
export const ADD_EMBED = 'ADD_EMBED';
export const ADD_IMAGE = 'ADD_IMAGE';
export const ADD_TILE = 'ADD_TILE';
export const ADD_TABLE_TILE = 'ADD_TABLE_TILE';
export const ADD_PROGRESS_TRACKER = 'ADD_PROGRESS_TRACKER';
export const ADD_VIDEO = 'ADD_VIDEO';
export const APPLY_BRANDING = 'APPLY_BRANDING';
export const CLEAR_CONTENT = 'CLEAR_CONTENT';
export const COPY_STORY = 'COPY_STORY';
export const COPY_TO_TEMPLATE = 'COPY_TO_TEMPLATE';
export const DELETE_CONTENT = 'DELETE_CONTENT';
export const DELETE_STORY = 'DELETE_STORY';
export const PDF_LOADING = 'PDF_LOADING';
export const REPUBLISH_STORY = 'REPUBLISH_STORY';
export const RESET_CONTENT = 'RESET_CONTENT';
export const SHARE_VISIBILITY_SETTINGS = 'SHARE_VISIBILITY_SETTINGS';
export const EXPORT_OPTIONS = 'EXPORT_OPTIONS';
export const STORY_SETTINGS = 'STORY_SETTINGS';
export const STORIES_GRANULAR_ACCESS = 'STORIES_GRANULAR_ACCESS';
export const BULK_STORIES_GRANULAR_ACCESS = 'BULK_STORIES_GRANULAR_ACCESS';
export const PUBLICATION_GRANULAR_ACCESS = 'PUBLICATION_GRANULAR_ACCESS';

export const MEDIA_BACKGROUND = 'background';
export const MEDIA_EMBED = 'embed';
export const MEDIA_IMAGE = 'image';
export const MEDIA_TABLE_TILE = 'tableTile';
export const MEDIA_TILE = 'tile';
export const MEDIA_VIDEO = 'video';
export const TIMELINE_CHART = 'timelineChart';
export const CUSTOM_SPREADSHEET_REPORT_MEDIA_TYPE = 'customSpreadsheet';

export const TAG_A = 'A';
export const TAG_DIV = 'DIV';
export const TAG_IMAGE = 'IMG';
export const TAG_SCRIPT = 'SCRIPT';
export const TAG_VIDEO = 'VIDEO';

export const MIME_IMAGE = 'image/*';
export const MIME_VIDEO = 'video/mp4';

export const HIDE_COLUMN = [{ id: 'hide', name: 'Hide Column' }];

export const SUMMARY_TABLE_EMBED_REQUEST = 'SUMMARY_TABLE_EMBED_REQUEST';

export const EMBED_IFRAME_DEFAULT_HEIGHT = 420;
export const EMBED_IFRAME_DEFAULT_WIDTH = 580;

export const STORY_DEFAULT_PADDING_PIXELS = 76;

export const SAVED_VIEW_FETCH_ERROR = 'Existing selected saved view is not available for Embed';
export const REPORT_FETCH_ERROR = 'Existing selected report is not available for Embed';
export const REQUEST_ERROR = 'Request Error';

export const PUBLICATION = 'publication';
export const SETUP_ONLINE_PUBLICATION_WARNING = 'SETUP_ONLINE_PUBLICATION_WARNING';
export const ADD_PROPOSAL_CONTENT = 'ADD_PROPOSAL_CONTENT';
export const REPLACE_BUDGET_PROPOSAL_CONTENT = 'REPLACE_BUDGET_PROPOSAL_CONTENT';
export const REPLACE_PROPOSAL_CONTENT = 'REPLACE_PROPOSAL_CONTENT';

export const FOLDER = 'folder';
export const MAX_STORY_ERROR = 'Currently the product only supports a maximum of 1000 stories in a single export. ';
